import React, { ReactElement } from 'react';
import styled from 'styled-components';
import {
  Link,
  FacebookLg,
  TwitterLg,
  LinkedinLg,
  paletteHelper,
} from '@rea-group/construct-kit-core';

const SocialLinksContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  & > * + * {
    margin-left: 1rem;
  }
`;

const IconLink = styled(Link)`
  color: ${paletteHelper('borderPrimary')};
  &:hover {
    color: ${paletteHelper('backgroundPrimaryInverted')};
  }
`;

const SocialLinks = (): ReactElement => (
  <SocialLinksContainer>
    <IconLink
      icon={<FacebookLg />}
      href="https://www.facebook.com/realestateAus"
      title="realestate.com.au Facebook"
      aria-label="Facebook"
      hideLabel
    >
      Facebook
    </IconLink>
    <IconLink
      icon={<TwitterLg />}
      href="https://twitter.com/realestate_au"
      title="realestate.com.au Twitter"
      aria-label="Twitter"
      hideLabel
    >
      Twitter
    </IconLink>
    <IconLink
      icon={<LinkedinLg />}
      href="https://www.linkedin.com/company/rea-group"
      title="realestate.com.au LinkedIn"
      aria-label="LinkedIn"
      hideLabel
    >
      LinkedIn
    </IconLink>
  </SocialLinksContainer>
);

export default SocialLinks;
